import angular from "angular";
import template from "./school-zones-index.html";
import AdminSchoolsZonesIndexController from "./school-zones-index.controller";

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.schools.zones.index", {
    url: "/:schoolId/index",
    controller: AdminSchoolsZonesIndexController,
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.schools.zones.index", [])
  .config(config)
  .controller(
    "AdminSchoolsZonesIndexController",
    AdminSchoolsZonesIndexController,
  );
